import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import MultiDropdownInput from "../components/MultiDropdownInput";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (field: string, value: string) => {
      dispatch(actions.updateUi(field, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MultiDropdownInput);
